import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delete_img",
  "use": "icon-delete_img-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-delete_img\"><path d=\"M0 0l1024 1024V248.242424c0-137.153939-111.088485-248.242424-248.242424-248.242424H0z\" fill=\"#FF6625\" p-id=\"2919\" /><path d=\"M815.879758 456.362667l-248.242425-248.242425a31.030303 31.030303 0 0 1 43.876849-43.876848l248.242424 248.242424a31.030303 31.030303 0 0 1-43.876848 43.876849z\" fill=\"#FFFFFF\" p-id=\"2920\" /><path d=\"M567.637333 412.485818l248.242425-248.242424a31.030303 31.030303 0 0 1 43.876848 43.876848l-248.242424 248.242425a31.030303 31.030303 0 0 1-43.876849-43.876849z\" fill=\"#FFFFFF\" p-id=\"2921\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delete_img.svg
// module id = fDI7
// module chunks = 27